import AbstractShape from "@/Models/Shapes/AbstractShape";
import { PreviewShapeFactory } from "@/Models/Shapes/PreviewShapeFactory";
import ShapeConfigurationFactory from "@/Models/ShapeConfigurations/ShapeConfigurationFactory";
import { convertUnits } from "@/functions/numbers";

export default {
	namespaced: true,
	getters: {
		getInstance: ( state, getters, rootState, { measurements } ): AbstractShape => {
			return ( new PreviewShapeFactory() ).get( {
				shape: 'barrel',
				dimensions: measurements.dimensions,
				modifiers: measurements.modifiers,
			} );
		},
		cutoutMaximums: ( state, getters, rootState, { getCutoutMaximumRectangle } ): object => {
			return ( new ShapeConfigurationFactory() ).get_configuration( 'barrel' ).get_maximum_dimensions( getCutoutMaximumRectangle );
		},
		cutoutPrimitives: ( state, getters, rootState, { cutoutMeasurements } ): object => {
			return convertUnits( cutoutMeasurements.dimensions[ 'barrel' ] );
		},
		getCutoutArea: ( state, getters, rootState, { cutoutMeasurements, getArea } ): number => {
			return getArea( 'barrel', cutoutMeasurements.dimensions[ 'barrel' ] );
		},
		isCenteredShape: (): boolean => true,
		getArea: ( state, getters, rootState, { getArea, parsedDimensions } ): object => {
			return getArea( 'barrel', parsedDimensions );
		},
	},
};
